//
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

// components
import FilterSet from "shared/search/components/FilterSet/index"

// action creators
import {
    resetFilters,
    resetDefaultFilters,
    applyDefaultSearchFilters,
    storeProcessedDefaultFilters,
    closeAllFilterGroups,
} from "shared/search/action-creators"
import { setAiSearchApplied, setMobileFiltersOpenStatus } from "app/static/frontend/search-new/action-creators"

// selectors
import {
    selectAreAllDefaultFiltersActive,
    selectAreBelowSeeMoreFoldFiltersActive,
    selectAreMobileSearchFiltersOpen,
    selectAreNonDefaultFiltersActive,
    selectFlvHasDefaultFilters,
    selectPermissionedFilterGroupComponents,
} from "shared/search/selectors"

import { selectIsSearchifySubmittable, selectSearchifyHeaderName } from "shared/search/searchify/selectors"

const mapStateToProps = createStructuredSelector({
    allDefaultFiltersActive: selectAreAllDefaultFiltersActive,
    areBelowSeeMoreFoldFiltersActive: selectAreBelowSeeMoreFoldFiltersActive,
    areMobileSearchFiltersOpen: selectAreMobileSearchFiltersOpen,
    hasDefaultFilters: selectFlvHasDefaultFilters,
    isSearchifySubmittable: selectIsSearchifySubmittable,
    searchifyHeaderName: selectSearchifyHeaderName,
    nonDefaultFiltersActive: selectAreNonDefaultFiltersActive,
    permissionedFilterGroups: selectPermissionedFilterGroupComponents,
})

const actions = {
    applyDefaultSearchFilters,
    closeAllFilterGroups,
    resetDefaultFilters,
    resetFilters,
    setAiSearchApplied,
    storeProcessedDefaultFilters,
    setMobileFiltersOpenStatus,
}

export default connect(mapStateToProps, actions)(FilterSet)
